import { Injectable } from '@angular/core';
import { FormControl, FormGroup, Validators } from '@angular/forms';
import { forceAffirmativeValidation } from '@modules/business-accounts/forms/outside-tax/outside-tax.form';
import { IBaseFormBuilder } from '../../builders/base-builder.class';
import { forceValueValidator } from '../../config-step/validators/force-value.validator';

@Injectable({
    providedIn: 'root',
})
export class DataCollectionFormBuilder implements IBaseFormBuilder {
    private form: FormGroup;

    constructor() {
        this.form = new FormGroup({});
    }

    public build() {
        this.addDataCollectionForm();
    }

    public getResult(): FormGroup {
        return this.form;
    }

    private addDataCollectionForm() {
        this.form.addControl(
            'dataCollection', new FormGroup({
                ruc: new FormControl(null, [
                    Validators.required,
                    Validators.pattern(/^10|20/),
                    Validators.minLength(11),
                ]),
                // representative: new FormControl(null, [
                //     Validators.required,
                //     forceAffirmativeValidation
                // ]),
                taxResidence: new FormControl(null, [
                    Validators.required,
                    forceAffirmativeValidation
                ]),
                documentType: new FormControl(null, [Validators.required]),
                documentNumber: new FormControl(null, [
                    Validators.required,
                    Validators.minLength(8),
                ]),
                privacyPolicy: new FormControl(false, [forceValueValidator(true)]),
                identityByBiometrics: new FormControl(false, [forceValueValidator(true)])
            }));
    }
}

export const getDataCollectionFormInstance = ({ from: form }: { from: FormGroup }) =>
    form.get('dataCollection') as FormGroup;